import type * as ents from '@attain-apps/entities'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { AdditionalFilters } from '../../types'

import { State } from './state'

/**
 * Actions for duplicate employee detection
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /**
     * Loads duplicate employees for the current employee edit.
     */
    loadForCurrentEntity: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.asIs<readonly ents.extra.space.Employee[]>(),
      reducers: {
        cancellation: () => State.INITIAL,
        error: () => State.INITIAL,
        request: ({ state }) => ({
          ...state,
          isChecking: true,
        }),
        success: ({ state, data: { response: duplicates } }) => ({
          ...state,
          duplicates,
          isChecking: false,
        }),
      },
    }),
    /**
     * Searches for employees matching the given name and job title. Dispatched
     * by the current-entity coordinator once it has sampled edited employee
     * fields.
     */
    loadDuplicates: store.actions.request({
      input:
        store.actions.Data.asIs<
          Required.Semi<AdditionalFilters, 'name' | 'orgFilter'>
        >(),
      output: store.actions.Data.asIs<readonly ents.extra.space.Employee[]>(),
    }),
    selectDuplicates: store.actions.request({
      input: store.actions.Data.asIs<{
        target: ec.models.Target | undefined
      }>(),
      output: store.actions.Data.NONE,
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
